<template>
  <div>
    <CyberIncidentForm />
  </div>
</template>

<script>
import CyberIncidentForm from '@/components/cyber-incident/CyberIncidentForm.vue';

export default {
  name: 'CyberIncidentScreen',
  components: { CyberIncidentForm }
};
</script>
